define("shared/types/time-picker", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TimePeriodDirection = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let TimePeriodDirection = _exports.TimePeriodDirection = /*#__PURE__*/function (TimePeriodDirection) {
    TimePeriodDirection["Backward"] = "backward";
    TimePeriodDirection["Forward"] = "forward";
    return TimePeriodDirection;
  }({});
});